import { FC } from 'react';
import { FollowButton } from '@components/FollowButton/FollowButton';
import { ArtistAvatar } from '@components/UIKit/ArtistAvatar/ArtistAvatar';
import { useGetIsBlocked } from '@hooks/TRPC_Hooks/useGetIsBlocked';
import { useGetIsBlockedBy } from '@hooks/TRPC_Hooks/useGetIsBlockedBy';
import { profile } from '@prisma/client';
import { LinksEnum } from '@specs/navigation';
import cn from 'classnames';
import Link from 'next/link';
import s from './artistSmallCard.module.scss';
type ArtistSmallCardProps = {
  shortid?: string;
  name?: profile['name'];
  surname?: profile['surname'];
  className?: string;
};
export const ArtistSmallCard: FC<ArtistSmallCardProps> = ({
  shortid,
  name,
  surname,
  className
}) => {
  const {
    isBlocked
  } = useGetIsBlocked({
    targetShortId: shortid ?? ''
  });
  const {
    isBlocked: isBlockedByMe
  } = useGetIsBlockedBy({
    targetShortId: shortid ?? ''
  });
  if (!shortid) return null;
  const isBlock = isBlocked || isBlockedByMe;
  return <div className={cn(s.artistSmallCard, className)} data-sentry-component="ArtistSmallCard" data-sentry-source-file="ArtistSmallCard.tsx">
            <div className={s.artistSmallCard__left}>
                <ArtistAvatar className={s.artistSmallCard__avatar} shortId={shortid} srcSet={[{
        height: 40,
        width: 40,
        minMedia: 0
      }]} data-sentry-element="ArtistAvatar" data-sentry-source-file="ArtistSmallCard.tsx" />
                <div className={s.artistSmallCard__info}>
                    <Link href={{
          pathname: LinksEnum.USER,
          query: {
            slug: shortid
          }
        }} data-sentry-element="Link" data-sentry-source-file="ArtistSmallCard.tsx">
                        <b>@{shortid}</b>
                    </Link>
                    <span>{name ?? ''}{surname ?? ''}</span>
                </div>
            </div>
            {!isBlock && <FollowButton shortid={shortid} buttonProps={{
      color: 'Black',
      className: s.artistSmallCard__followButton,
      size: 'small'
    }} />}
        </div>;
};